import React from 'react';
import styled from '@emotion/styled';

const Columns = styled.div`
  display: flex;
  align-items: stretch;
  flex-wrap: wrap;

  & > * {
    &:first-of-type {
      margin-bottom: 2rem;
    }

    @media (min-width: 768px) {
      flex: 1;

      &:first-of-type {
        padding-right: 38px;
        margin-bottom: 0;
      }
    }
  }
`;

export default Columns;
